module.exports = __webpack_public_path__ + "static/img/index_top.267bb44.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/index_top.png
// module id = 250
// module chunks = 1